export function normalizeFilters(filters) {
    return Object.fromEntries(
        Object.entries(filters).filter(([, value]) => {
            if (Array.isArray(value)) {
                return value.length > 0;
            }
            return value !== null && value !== '' && value !== undefined;
        })
    );
}
